const baguetteConfig = {
  buttons: true,
  bodyClass: `qform-image-box-opened`,
  leftArrow: `
        <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.5L5 8.5L10 15.5" stroke="#828282" stroke-width="2"/>
        </svg>
      `,
  rightArrow: `
        <svg width="20" height="20" viewBox="0 0 8 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 8.5L1 15.5" stroke="#828282" stroke-width="2"/>
        </svg>
      `,
  closeX: `
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M1 13L13 1" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
  filter: /.+\.(gif|jpe?g|png|webp|bmp)/i,
  captions: true,
  onChange: (currentIndex, imagesCount) => {
    loopImage(currentIndex, imagesCount);
  }
};
export default baguetteConfig;
function loopImage(currentIndex, imagesCount) {
  const prevButton = document.querySelector("#previous-button");
  const nextButton = document.querySelector("#next-button");
  if (prevButton) {
    prevButton.style.display = currentIndex === 0 ? "none" : "flex";
  }
  if (nextButton) {
    nextButton.style.display = currentIndex === imagesCount - 1 ? "none" : "flex";
  }
}